import { HiOutlineArrowDownTray } from "react-icons/hi2";

import { useOptionalInstall, useOptionalPwa } from "./pwaServices";

/**
 * Кнопка «Установить приложение» для экрана входа.
 *
 * Основное место установки — страница «О приложении» с инструкциями для всех
 * браузеров: боковое меню и так заполнено. На экране входа кнопка нужна, потому
 * что с него начинают на телефоне, до входа в систему, а инструкции за входом.
 * Поэтому здесь она только там, где браузер сам разрешил установку и откроет
 * системный диалог. Вне провайдера и в установленном приложении не рисуется.
 */
export function InstallButton() {
  const pwa = useOptionalPwa();
  const state = useOptionalInstall();

  if (pwa === null || state === null || !state.canPrompt) return null;

  return (
    <button
      className="button button--secondary button--compact"
      type="button"
      onClick={() => void pwa.installer.prompt()}
    >
      <HiOutlineArrowDownTray aria-hidden="true" />
      Установить приложение
    </button>
  );
}
